import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import GetIcon from '../../utils/Icon';


const Breadcrumb = ({ items, className = '' }) => {
  return (
    <div className={`d-flex align-items-center ${className}`}>
      {items.map((item, index) => (
        <div key={index} className="d-flex align-items-center">
          {index > 0 && (
            <span className="">
              <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />
            </span>
          )}

          {item.url ? (
            <Link
              to={item.url}
              className={index === items.length - 1 ? 'breadcrumb-item ' : 'breadcrumb-item1'}
            >
              {item.label}
            </Link>
          ) : (
            <span className="breadcrumb-item" style={item?.style}>{item.label}</span>
          )}
        </div>
      ))}
    </div>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string,
    })
  ).isRequired,
  className: PropTypes.string,
};

export default Breadcrumb;
